export const DREAM_CASH_BUCKETS = ["unplayed_dc", "freebet_dc", "sticky_dc", "redeemable_dc"];
const number = value => Number.isFinite(Number(value)) ? Number(value) : 0;
export const formatCoins = value => number(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const totalDreamCash = wallet => DREAM_CASH_BUCKETS.reduce((sum, key) => sum + number(wallet?.[key]), 0);
export const playThroughPercent = wallet => {
  const target = number(wallet?.target_volume);
  if (target <= 0) return 100;
  return Math.min(100, Math.max(0, Math.round(number(wallet?.current_volume_played) / target * 100)));
};
export const remainingVolume = wallet => Math.max(0, number(wallet?.target_volume) - number(wallet?.current_volume_played));
